import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { Box, Typography, Switch } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { StyledTooltip } from "../tooltip/Tooltip.js";
import { isStringNullOrEmpty } from "../../utils/string.js";
import "moment-timezone";
import "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
import "../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
const localized = defineMessages({
  disabled: {
    id: "ToggleSwitch_disabled",
    defaultMessage: "Toggle is disabled"
  }
});
const useClasses = makeStyles()((theme, _params, classes) => ({
  toggleSwitch: {
    display: "flex",
    columnGap: theme.spacing(1),
    alignItems: "center"
  },
  toggleSwitchAligned: {
    justifyContent: "flex-start"
  },
  toggleSwitchWithBorder: {
    borderBottom: `1px solid ${theme.palette.secondary.light}`
  },
  toggleSwitchWithFieldLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [`& .${classes.toggleSwitch}`]: {
      marginLeft: theme.spacing(1.5)
    }
  },
  toggleSwitchLabelAlignRight: {
    flexDirection: "row-reverse"
  },
  toggleSwitchVerticalPaddings: {
    padding: theme.spacing(1.5, 0)
  }
}));
function ToggleSwitch({
  fieldName,
  value,
  label,
  onChange,
  disabled,
  className,
  withBorder,
  alignLeft,
  labelAlignRight,
  withVerticalPaddings
}) {
  const { classes, cx } = useClasses();
  const { formatMessage } = useIntl();
  function renderSwitch() {
    return /* @__PURE__ */ React.createElement(Switch, { checked: value, onChange: (event) => onChange(event?.target?.checked), disabled, color: "secondary" });
  }
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(
        {
          [classes.toggleSwitchAligned]: alignLeft,
          [classes.toggleSwitchWithBorder]: withBorder,
          [classes.toggleSwitchWithFieldLabel]: !isStringNullOrEmpty(fieldName),
          [classes.toggleSwitchVerticalPaddings]: withVerticalPaddings
        },
        className
      )
    },
    /* @__PURE__ */ React.createElement(Typography, null, fieldName),
    /* @__PURE__ */ React.createElement(
      Box,
      {
        className: cx(classes.toggleSwitch, {
          [classes.toggleSwitchLabelAlignRight]: labelAlignRight
        })
      },
      label ? /* @__PURE__ */ React.createElement(Typography, { variant: "subtitle2", color: disabled ? "textSecondary" : void 0 }, /* @__PURE__ */ React.createElement(LocalizedText, { label })) : null,
      disabled ? /* @__PURE__ */ React.createElement(StyledTooltip, { title: formatMessage(localized.disabled), element: /* @__PURE__ */ React.createElement("div", null, renderSwitch()) }) : renderSwitch()
    )
  );
}
export {
  ToggleSwitch
};
//# sourceMappingURL=ToggleSwitch.js.map
